import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App' // Import the main App component
import TagManager from 'react-gtm-module'

TagManager.initialize({ gtmId: 'GTM-PRWW267' })

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
